import { useId, useState } from "react";
import Dialog from "../../../../components/dialog/Dialog";
import DialogButton from "../../../../components/dialog/DialogButton";
import styles from "./rolesPermissions.module.css";

// Asks for a role name: a new role, a copy, or a rename. `currentName` is the
// name being replaced ("" when there is none); submitting it unchanged is off.
// Escape, a click outside or × close it, unless a request is running.
const RoleNameDialog = ({
  title,
  hint,
  initialName,
  currentName,
  submitLabel,
  busy,
  error,
  onSubmit,
  onClose,
}) => {
  const formId = useId();
  const [name, setName] = useState(initialName);
  const trimmed = name.trim();
  const canSubmit = !busy && trimmed.length > 0 && trimmed !== currentName;
  const close = () => {
    if (!busy) onClose();
  };

  return (
    <Dialog
      title={title}
      size="sm"
      onClose={close}
      closeOnEscape={!busy}
      closeOnBackdrop={!busy}
      footer={
        <>
          <DialogButton variant="secondary" onClick={close} disabled={busy}>
            إلغاء
          </DialogButton>
          <DialogButton
            variant="primary"
            type="submit"
            form={formId}
            disabled={!canSubmit}
          >
            {busy ? "جارٍ الحفظ…" : submitLabel}
          </DialogButton>
        </>
      }
    >
      <form
        id={formId}
        className={styles.dialogBody}
        onSubmit={(event) => {
          event.preventDefault();
          if (canSubmit) onSubmit(trimmed);
        }}
      >
        <label className={styles.dialogLabel}>
          اسم الدور
          <input
            className={styles.dialogInput}
            value={name}
            onChange={(event) => setName(event.target.value)}
            maxLength={50}
            dir="auto"
            autoFocus
            disabled={busy}
          />
        </label>
        {hint && <p className={styles.dialogHint}>{hint}</p>}
        {error && <p className={styles.dialogError}>{error}</p>}
      </form>
    </Dialog>
  );
};

export default RoleNameDialog;
